// Result: 9 days ago, 11:47 AM
// Result: Yesterday, 3:50 PM

export const howMuchDaysAgo = (timestampStr: string) => {
    const timestamp = new Date(timestampStr)
    const today = new Date()

    // Calculate the difference in days between the timestamp and today
    const differenceInDays = Math.floor(
        (today.getTime() - timestamp.getTime()) / (1000 * 60 * 60 * 24)
    )

    // Function to format the time
    function formatTime(date: Date) {
        let hours = date.getHours()
        let minutes = date.getMinutes()
        const ampm = hours >= 12 ? 'PM' : 'AM'
        hours = hours % 12
        hours = hours ?? 12 // Handle midnight
        minutes = minutes < 10 ? Number('0' + minutes) : minutes
        const formattedTime = hours + ':' + minutes + ' ' + ampm
        return formattedTime
    }

    // Format the days ago and time
    const formattedTime = formatTime(timestamp)
    if (differenceInDays === 0) {
        return 'Today, ' + formattedTime
    } else if (differenceInDays === 1) {
        return 'Yesterday, ' + formattedTime
    } else {
        return differenceInDays + ' days ago, ' + formattedTime
    }
}
